import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import {
  useGetOptionListQuery,
  usePendingLeadQuery,
} from "../redux/api/LeadApi";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import Logout from "../components/Logout";

const Pendinglist = () => {
  const isFirstRender = useRef(true);
  const [showLogout, setShowLogout] = useState(false);
  const [addClass, setAddClass] = useState("");
  const [addSideClass, setSideAddClass] = useState("");
  const [search, setSearch] = useState("");
  const [inputVal, setInputVal] = useState({
    leadStatus: "",
    // firstDate: "",
    // lastDate: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [lidParamData, setLidParamData] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const userData = JSON.parse(localStorage.getItem("userData"));
  let id = userData?.data?.user_id;
  const { data, isLoading } = usePendingLeadQuery(id);
  const handleChangeFilter = (e) => {
    setInputVal({
      ...inputVal,
      [e.target.name]: e.target.value,
    });
  };
  const { data: optionList } = useGetOptionListQuery();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (!isLoading && data) {
      setFilteredData(
        data?.leadid?.filter((result) => {
          let leadDate = new Date(result.created_at);
          let followupDate = new Date(
            result.leadassignlist?.leadfollowup[0]?.date
          );
          return (
            (today > leadDate && [10].includes(Number(result.leadstatus))) ||
            (today > followupDate &&
              ![10, 13, 16, 18].includes(Number(result.leadstatus)))
          );
        })
      );
    }
  }, [data, isLoading]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lidParams = urlParams.get("lid");

    if (lidParams) {
      const lidIds = lidParams.split(",").map((id) => parseInt(id));
      const filteredByLids =
        data?.leadid?.filter((item) => lidIds.includes(item.id)) || [];
      setLidParamData(
        filteredByLids?.filter((result) => {
          let leadDate = new Date(result.created_at);
          let followupDate = new Date(
            result.leadassignlist?.leadfollowup[0]?.date
          );
          return (
            (today > leadDate && [10].includes(Number(result.leadstatus))) ||
            (today > followupDate &&
              ![10, 13, 16, 18].includes(Number(result.leadstatus)))
          );
        })
      );
    }
  }, [data]);

  const handleFilterButtonClick = () => {
    let filtered = data?.leadid || [];

    if (inputVal.leadStatus) {
      filtered = filtered.filter(
        (item) => item.leadstatus === Number(inputVal.leadStatus)
      );
    }

    // if (inputVal.firstDate && !inputVal.lastDate) {
    //   filtered = filtered.filter(
    //     (item) =>
    //       new Date(item.created_at).toDateString() ===
    //       new Date(inputVal.firstDate).toDateString()
    //   );
    // }

    // if (inputVal.firstDate && inputVal.lastDate) {
    //   filtered = filtered.filter(
    //     (item) =>
    //       new Date(item.created_at) >= new Date(inputVal.firstDate) &&
    //       new Date(item.created_at) <= new Date(inputVal.lastDate)
    //   );
    // }

    if (search) {
      filtered = filtered.filter(
        (item) => item.name.includes(search) || item.mobile.includes(search)
      );
    }

    setFilteredData(filtered);
  };

  const dateFormat = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDate = `${day < 10 ? "0" : ""}${day}-${
      month < 10 ? "0" : ""
    }${month}-${year}`;
    return formattedDate;
  };
  const getStatusName = (leadstatus) => {
    const statusName = optionList?.data?.leadstatus?.find(
      (opt) => opt.id === leadstatus
    );
    return statusName ? statusName.name : "Unknown Status";
  };

  useEffect(() => {
    if (isFirstRender.current) {
      // Skip the first render
      isFirstRender.current = false;
      return;
    }

    let filtered = data?.leadid || [];

    if (search) {
      // if (isNaN(search)) {
      //   filtered = filtered.filter((item) => item.name === search);
      // } else if (!isNaN(search)) {
      //   filtered = filtered.filter(
      //     (item) => Number(item.mobile) === Number(search)
      //   );
      // }
      filtered = filtered.filter(
        (item) => item.name.includes(search) || item.mobile.includes(search)
      );
    }
    if (inputVal.leadStatus) {
      filtered = filtered.filter(
        (item) => item.leadstatus === Number(inputVal.leadStatus)
      );
    }

    // if (inputVal.firstDate && !inputVal.lastDate) {
    //   filtered = filtered.filter(
    //     (item) =>
    //       new Date(item.created_at).toDateString() ===
    //       new Date(inputVal.firstDate).toDateString()
    //   );
    // }

    // if (inputVal.firstDate && inputVal.lastDate) {
    //   filtered = filtered.filter(
    //     (item) =>
    //       new Date(item.created_at) >= new Date(inputVal.firstDate) &&
    //       new Date(item.created_at) <= new Date(inputVal.lastDate)
    //   );
    // }
    setFilteredData(filtered);
  }, [search]);

  const pendingLeadsData = (
    lidParamData.length > 0 ? lidParamData : filteredData
  )?.filter((result) => ![13, 16, 18].includes(Number(result?.leadstatus)));

  const startRecord = (page - 1) * 10 + 1;
  const endRecord = Math.min(page * 10, pendingLeadsData?.length);

  return (
    <>
      <>
        <div className="main-context position-absolute  top-0  w-100 z-0"></div>
        <Sidebar addSideClass={addSideClass} />
        <div className={`dashnoard ${addClass}`}>
          <Navbar
            setShowLogout={setShowLogout}
            setSideAddClass={setSideAddClass}
            setAddClass={setAddClass}
            addClass={addClass}
            addSideClass={addSideClass}
          />
          <div className="container mt-2 bg-white  position-relative  pt-3">
            <div className="container-fluid">
              <div className="d-flex justify-content-between">
                <div className="heading fs-4 mb-3">Manage Lead</div>
                <div className="mb-3 w-50">
                  <input
                    type="text"
                    name="mobile"
                    id="mobile"
                    className="form-control border-color shadow-none"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search Lead By Name/Mobile"
                  />
                </div>
              </div>
              <div className="row justify-content-start gy-2 align-items-end mb-4">
                <div className="col-lg-6 col-12 col-xl-6">
                  <label htmlFor="leadStatus">Select Lead Status</label>
                  <select
                    name="leadStatus"
                    id="leadStatus"
                    value={inputVal.leadStatus}
                    onChange={handleChangeFilter}
                    className="form-select form-control border-color shadow-none"
                    aria-label=".form-select-lg example"
                  >
                    <option>Select Lead Status</option>
                    {optionList &&
                      optionList?.data?.leadstatus?.map((result) => {
                        return (
                          <option key={result?.id} value={result?.id}>
                            {result?.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="col-3 col-lg-2">
                  <i
                    class="bi bi-search fs-4"
                    style={{ cursor: "pointer", color: "gray" }}
                    onClick={handleFilterButtonClick}
                  ></i>
                  <i
                    class="bi bi-x-circle fs-4 ps-4"
                    style={{ cursor: "pointer", color: "gray" }}
                    onClick={() => window.location.reload()}
                  ></i>
                </div>
                {/* <div className="col-lg-4 col-6 col-xl-4 ">
                  <label htmlFor="leadStatus">Start Date</label>
                  <div className="mb-3">
                    <input
                      type="date"
                      name="firstDate"
                      id="firstDate"
                      className="form-control border-color shadow-none"
                      value={inputVal.firstDate}
                      onChange={handleChangeFilter}
                      placeholder="First Date"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-6 col-xl-4 ">
                  <label htmlFor="leadStatus">End Date</label>
                  <div className="mb-3">
                    <input
                      type="date"
                      name="lastDate"
                      id="lastDate"
                      className="form-control border-color shadow-none"
                      value={inputVal.lastDate}
                      onChange={handleChangeFilter}
                      placeholder="Last Date"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className=" w-100 mb-4">
              <div className="container">
                <div className="row justify-content-center  text-center manage-lead-btn">
                  <div className="col-6">
                    <button
                      onClick={handleFilterButtonClick}
                      type="button"
                      className="btn btn-outline-secondary button-two w-100"
                    >
                      Filter
                    </button>
                  </div>
                  <div className="col-6">
                    <Link
                      type="button"
                      className="btn btn-outline-secondary button-one  w-100"
                      onClick={() => window.location.reload()}
                    >
                      Reset
                    </Link>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="manage-lead-table  update-list">
              <div className="container-fluid mb-4">
                <div className="row">
                  <div className="col-12">
                    <h4 className="fs-5 fw-medium mt-2">
                      {!isLoading &&
                        `Showing  ${startRecord}-${endRecord} of ${pendingLeadsData?.length} Record(s)`}
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="table-wrapper overflow-auto ">
                      <table className="table table-borderless text-center">
                        <thead>
                          <tr id="table-heading">
                            <th
                              scope="col"
                              className="fixed-column sticky-col first-col"
                            >
                              S.No
                            </th>
                            <th
                              scope="col"
                              className="fixed-column sticky-col second-col"
                            >
                              Name
                            </th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Project</th>
                            <th scope="col">Lead Source</th>
                            <th scope="col">Creation Date</th>
                            <th scope="col">Follow Up</th>
                            <th scope="col">Status</th>
                            <th className="px-md-4 px-sm-4 px-4">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <tr className="w-100  bg-white   ">
                              <td></td>
                              <td></td>
                              <td></td>
                              <Loader />
                              <td></td>
                              <td></td>
                            </tr>
                          ) : (
                            // (lidParamData.length > 0
                            //   ? lidParamData
                            //   : filteredData
                            // )
                            //   ?.filter(
                            //     (result) =>
                            //       ![13, 16, 18].includes(
                            //         Number(result?.leadstatus)
                            //       )
                            //   )
                            pendingLeadsData
                              ?.slice(startRecord - 1, page * itemsPerPage)
                              ?.map((result, index) => {
                                return (
                                  <tr id="table-data" key={result?.id}>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching sticky-col first-col`}
                                    >
                                      {startRecord - 1 + (index + 1)}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-capitalize text-matching sticky-col second-col`}
                                    >
                                      {result?.name}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching`}
                                    >
                                      {result?.mobile}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching`}
                                    >
                                      {result?.project}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching`}
                                    >
                                      {result?.leadsource}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching date-create`}
                                    >
                                      {dateFormat(result?.created_at)}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4 text-matching date-create`}
                                    >
                                      {result.leadassignlist?.leadfollowup[0]
                                        ?.date &&
                                      result.leadassignlist?.leadfollowup[0]
                                        ?.date !== "null"
                                        ? dateFormat(
                                            result.leadassignlist
                                              ?.leadfollowup[0]?.date
                                          )
                                        : "-"}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4  text-matching`}
                                    >
                                      {getStatusName(result?.leadstatus)}
                                    </td>
                                    <td
                                      className={`px-md-4 px-sm-4 px-4  text-matching`}
                                    >
                                      <Link
                                        to={`/managelead/${result?.id}`}
                                        className="text-primary"
                                      >
                                        <span>
                                          {" "}
                                          {/* <i className="bi bi-eye-fill eye-icon mx-3 mx-md-0"></i> */}
                                          View
                                        </span>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })
                          )}
                          {!isLoading && pendingLeadsData?.length <= 0 && (
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>No Record Found</td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {!isLoading && pendingLeadsData?.length > 0 && (
                      <div aria-label="Page navigation example ">
                        <ul className="pagination justify-content-center bg-transparent ">
                          <li
                            className="page-item  bg-transparent shadow-none "
                            onClick={() => setPage(page - 1)}
                          >
                            <button
                              className={`page-link  text-white shadow-none `}
                              disabled={page === 1}
                            >
                              Prev
                            </button>
                          </li>
                          <li className="page-item disabled bg-transparent shadow-none ">
                            <Link
                              className="page-link text-white"
                              style={{
                                backgroundColor: "#EF4347",
                              }}
                            >
                              {page} of{" "}
                              {Math.ceil(
                                pendingLeadsData?.length / itemsPerPage
                              )}
                            </Link>
                          </li>
                          <li
                            className="page-item shadow-none "
                            onClick={() => setPage(page + 1)}
                          >
                            <button
                              className="page-link  text-white shadow-none "
                              disabled={
                                page ===
                                Math.ceil(
                                  pendingLeadsData?.length / itemsPerPage
                                )
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {showLogout && <Logout setShowLogout={setShowLogout} />}
      </>
    </>
  );
};

export default Pendinglist;
